import angular from 'angular';

import templateUrl from './edit-division-payout-policy.component.html';

export const EditDivisionPayoutPolicyComponent = {
    controller: EditDivisionPayoutPolicyController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        divisionPayoutPolicy: "<",
        addPolicy: "<addPolicy",
        validatePolicy: "<validatePolicy",
        updatePolicy: "<updatePolicy",
        removePolicy: "<removePolicy",
        removeDivisionPolicy: "<removeDivisionPolicy",
        saveDivisionPolicy: "<saveDivisionPolicy",
        divisions: "<",
        save: "<",
        isAdminView: "<"
    }
}
function EditDivisionPayoutPolicyController(utilityService, apexApiUrl) {
    'ngInject';
    const vm = this;
    vm.policy;
    vm.addPayoutPolicy = addPayoutPolicy;
    vm.validatePayoutPolicy = validatePayoutPolicy;
    vm.updatePayoutPolicy = updatePayoutPolicy;
    vm.removePayoutPolicy = removePayoutPolicy;
    vm.removeDivisionPayoutPolicy = removeDivisionPayoutPolicy;
    vm.saveDivisionPayoutPolicy = saveDivisionPayoutPolicy;
    vm.copyPayoutPolicy = copyPayoutPolicy;
    vm.exportPayoutPolicy = exportPayoutPolicy;

    function updatePayoutPolicy(policy) {
        vm.updatePolicy(policy, vm.divisionPayoutPolicy);
    }

    function validatePayoutPolicy(policy) {
        vm.validatePolicy(policy, vm.divisionPayoutPolicy);
    }

    function addPayoutPolicy() {
        vm.addPolicy(vm.divisionPayoutPolicy);
    }

    function removePayoutPolicy(policy) {
        vm.removePolicy(vm.divisionPayoutPolicy, policy);
    }

    function removeDivisionPayoutPolicy() {
        vm.removeDivisionPolicy(vm.divisionPayoutPolicy);
    }

    function saveDivisionPayoutPolicy() {
        vm.saveDivisionPolicy(vm.divisionPayoutPolicy);
    }

    function exportPayoutPolicy(policy) {
        console.log(policy);
        const params = {
            DivisionID: policy.Division.Id,
            PayoutPolicyID: policy.PayoutPolicyID,
            RepPayoutPolicyID: policy.RepPayoutPolicyID
        };
        const queryString = utilityService.queryStringify(params);
        window.location.href = apexApiUrl + "payout-policy-report.xlsx"
            + queryString;
    }

    function copyPayoutPolicy(policy) {
        if (confirm("This action will undo all changes to the current policy. Are you sure you want to continue?")) {
            const index = vm.divisionPayoutPolicy.PayoutPolicies.indexOf(policy);
            const previousPolicy = angular.copy(vm.divisionPayoutPolicy.PayoutPolicies[index + 1]);
            policy.PayoutSplittingModifier = previousPolicy.PayoutSplittingModifier
            policy.RepPayoutSplittingModifier = previousPolicy.RepPayoutSplittingModifier
            policy.SplittingModifierType = previousPolicy.SplittingModifierType
            policy.MultiPlayCommissions = previousPolicy.MultiPlayCommissions
            policy.ProductCommissions = previousPolicy.ProductCommissions;
            policy.MultiPlayCommissionPayoutPolicies = previousPolicy.MultiPlayCommissionPayoutPolicies
            policy.ProductCommissionPayoutPolicies = previousPolicy.ProductCommissionPayoutPolicies;
            policy.RepProductCommissionPayoutPolicies = previousPolicy.RepProductCommissionPayoutPolicies
            policy.RepMultiPlayCommissionPayoutPolicies = previousPolicy.RepMultiPlayCommissionPayoutPolicies;
        }
    }

}
